var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentalHealthNewIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_88025",
    "data-name": "Group 88025",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64.696,
    height: 63,
    viewBox: "0 0 64.696 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25586",
    "data-name": "Rectangle 25586",
    width: 64.696,
    height: 63,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88024",
    "data-name": "Group 88024",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308334",
    "data-name": "Path 308334",
    d: "M17.05,14.6V10.011H10.31V14.6L3.128,18.04A5.042,5.042,0,0,0,.264,22.594V36.115H27.107V22.594A5.045,5.045,0,0,0,24.24,18.04Z",
    transform: "translate(0.428 16.22)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308335",
    "data-name": "Path 308335",
    d: "M10.31,14.6,3.128,18.04A5.042,5.042,0,0,0,.264,22.594V36.115h2.35V23.7a5.044,5.044,0,0,1,2.861-4.554l7.185-3.435v-5.7H10.31Z",
    transform: "translate(0.428 16.22)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308336",
    "data-name": "Path 308336",
    d: "M17.991,15.984a1.106,1.106,0,0,0-1.106,1.106v7.274H6.241a1.038,1.038,0,0,0,0,2.075H19.1V17.09a1.106,1.106,0,0,0-1.106-1.106",
    transform: "translate(8.435 25.899)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308337",
    "data-name": "Path 308337",
    d: "M10.447,25.028A8.175,8.175,0,0,0,18.6,16.916L13.762,14.6V10.011H7.023V14.6l-4.73,2.261a8.174,8.174,0,0,0,8.154,8.162",
    transform: "translate(3.715 16.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308338",
    "data-name": "Path 308338",
    d: "M9.1,15.122v-5.11H7.024v4.593L2.292,16.867a8.219,8.219,0,0,0,.33,2.269l5.7-2.772A1.378,1.378,0,0,0,9.1,15.122",
    transform: "translate(3.714 16.222)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308339",
    "data-name": "Path 308339",
    d: "M14.295,10.437A11,11,0,0,1,5.708,6.124s-2.036.22-2.4,4.093v3.034a5.494,5.494,0,1,0,10.987,0Z",
    transform: "translate(5.36 9.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308340",
    "data-name": "Path 308340",
    d: "M5.658,13.251V10.217a6.25,6.25,0,0,1,.956-3.05,8.6,8.6,0,0,1-.9-1.043s-2.039.22-2.4,4.093v3.034A5.507,5.507,0,0,0,8.8,18.77a5.408,5.408,0,0,0,1.174-.128,5.512,5.512,0,0,1-4.318-5.39",
    transform: "translate(5.36 9.922)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308341",
    "data-name": "Path 308341",
    d: "M24.964,27.261l-5.031-2.4a11.7,11.7,0,0,0,4.145-7.987C23.853,6.689,15.761.612,9.755,5.861c-4.62.8-5.66,5.511-5.505,11.613-.005.464,0,5.78,3.668,7.557l-4.664,2.23A5.765,5.765,0,0,0,0,32.439V45.962a.693.693,0,0,0,.692.692h26.84a.694.694,0,0,0,.692-.692V32.439A5.764,5.764,0,0,0,24.964,27.261ZM9.357,13.8c.207-2.136.933-2.953,1.4-3.26h.113a11.637,11.637,0,0,0,8.094,4.119V16.8a4.8,4.8,0,1,1-9.606,0Zm1.677,11.278a.689.689,0,0,0,.393-.624V22.366a6.134,6.134,0,0,0,5.356.052v2.031a.694.694,0,0,0,.393.624L21.6,27.188A7.46,7.46,0,0,1,6.711,27.14ZM26.84,45.27H22V38.492a.692.692,0,0,0-1.384,0V45.27H7.6V38.492a.69.69,0,0,0-1.381,0V45.27H1.384V32.439a4.375,4.375,0,0,1,2.468-3.93l1.536-.734a8.837,8.837,0,0,0,17.543.047l1.439.687a4.376,4.376,0,0,1,2.471,3.93Z",
    transform: "translate(0 6.375)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308342",
    "data-name": "Path 308342",
    d: "M31.66,18.613V12.958H24.329v5.655l-7.5,2.911a6.138,6.138,0,0,0-3.92,5.723V41.312H43.1V27.249a6.141,6.141,0,0,0-3.92-5.725Z",
    transform: "translate(20.909 20.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308343",
    "data-name": "Path 308343",
    d: "M24.33,18.613l-7.507,2.911A6.139,6.139,0,0,0,12.9,27.247V41.312h2.626V28.646a6.083,6.083,0,0,1,4.127-5.759l7.3-2.476V12.958H24.33Z",
    transform: "translate(20.91 20.996)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308344",
    "data-name": "Path 308344",
    d: "M22.02,18.1l-.611,2.471H18.483L17.872,18.1l2.075-1.7Z",
    transform: "translate(28.958 26.573)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308345",
    "data-name": "Path 308345",
    d: "M19.531,18.651l1.583-1.294L19.945,16.4l-2.073,1.7.611,2.471h1.522Z",
    transform: "translate(28.959 26.573)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308346",
    "data-name": "Path 308346",
    d: "M21.967,17.992H19.04L17.528,27.2l2.958,3.451L23.479,27.2Z",
    transform: "translate(28.401 29.152)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308347",
    "data-name": "Path 308347",
    d: "M19.6,26.512,21,17.991h-1.96L17.528,27.2l2.958,3.448,1.342-1.546Z",
    transform: "translate(28.402 29.151)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308348",
    "data-name": "Path 308348",
    d: "M16.017,16.384l3.27-1.268,3.666,3.367-3.409,2.785Z",
    transform: "translate(25.953 24.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308349",
    "data-name": "Path 308349",
    d: "M20.563,19.665l1.446-1.184-3.663-3.364-1.748.676Z",
    transform: "translate(26.894 24.493)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308350",
    "data-name": "Path 308350",
    d: "M25.6,16.384l-3.27-1.268-3.663,3.367,3.406,2.785Z",
    transform: "translate(30.242 24.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308351",
    "data-name": "Path 308351",
    d: "M20.11,19.665l-1.446-1.184,3.663-3.364,1.748.676Z",
    transform: "translate(30.241 24.493)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308352",
    "data-name": "Path 308352",
    d: "M24.594,12.958H17.265v5.655l3.663,3.367,3.666-3.367Z",
    transform: "translate(27.975 20.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308353",
    "data-name": "Path 308353",
    d: "M19.476,18.2V12.958H17.265v5.655l3.666,3.367,1.4-1.276Z",
    transform: "translate(27.975 20.995)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308354",
    "data-name": "Path 308354",
    d: "M22.72,10.57A2.715,2.715,0,1,1,20,13.285a2.718,2.718,0,0,1,2.72-2.715",
    transform: "translate(32.406 17.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308355",
    "data-name": "Path 308355",
    d: "M17.974,10.57a2.715,2.715,0,1,1-2.72,2.715,2.718,2.718,0,0,1,2.72-2.715",
    transform: "translate(24.716 17.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308356",
    "data-name": "Path 308356",
    d: "M16.279,11.643s6.236,1.436,9.593-2.712l2.877,2.392v5.849a6.235,6.235,0,0,1-12.47,0Z",
    transform: "translate(26.377 14.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308357",
    "data-name": "Path 308357",
    d: "M18.768,15.495V10.207a12.336,12.336,0,0,1-2.489-.241v5.529a6.23,6.23,0,0,0,6.236,6.223,6.305,6.305,0,0,0,1.245-.123A6.231,6.231,0,0,1,18.768,15.495Z",
    transform: "translate(26.377 16.148)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308358",
    "data-name": "Path 308358",
    d: "M39.85,31.612l-7.072-2.741V26.738a6.983,6.983,0,0,0,2.212-3.2,3.413,3.413,0,0,0,3.066-3.388V15.966a9.628,9.628,0,1,0-19.257,0v4.182a3.412,3.412,0,0,0,3.026,3.383,6.933,6.933,0,0,0,2.24,3.228v2.112L17,31.612a6.873,6.873,0,0,0-4.36,6.367V52.045a.693.693,0,0,0,.692.692H43.524a.7.7,0,0,0,.692-.692V37.979A6.874,6.874,0,0,0,39.85,31.612ZM35.336,21.379V18.245a2.017,2.017,0,0,1-.037,3.813,6.463,6.463,0,0,0,.037-.679M20.182,20.148a2.031,2.031,0,0,1,1.3-1.887v3.118c0,.225.013.448.034.666A2.024,2.024,0,0,1,20.182,20.148ZM34.272,30.93,31.7,34.5l-2.219-1.819,2.759-2.534Zm-4.549,3.734-.38,1.522H27.5l-.377-1.522,1.3-1.061Zm-4.276-5.623V27.629a6.922,6.922,0,0,0,5.951-.013v1.423l-2.977,2.733Zm-2.584-7.662V16.668c1.811.241,6.1.422,8.975-2.571l2.115,1.758v5.524a5.545,5.545,0,0,1-11.089,0Zm1.745,8.765,2.759,2.534L25.145,34.5l-2.573-3.564ZM42.832,51.353H37.495V44.121a.692.692,0,0,0-1.384,0v7.232H20.743V44.121a.692.692,0,0,0-1.384,0v7.232H14.022V37.979A5.481,5.481,0,0,1,17.5,32.9l3.739-1.449L24.453,35.9a.7.7,0,0,0,1,.131l.485-.4.312,1.273-1.488,9.072a.712.712,0,0,0,.157.561l2.964,3.448a.691.691,0,0,0,1.043,0l2.992-3.448a.7.7,0,0,0,.16-.563l-1.025-6.242a.692.692,0,0,0-1.365.223l.972,5.922-2.253,2.6-2.225-2.6,1.36-8.314h2.343a.7.7,0,0,0,.673-.527l.346-1.41.485.4a.694.694,0,0,0,1-.131L35.6,31.449,39.35,32.9a5.481,5.481,0,0,1,3.482,5.078V51.353Z",
    transform: "translate(20.482 10.266)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308359",
    "data-name": "Path 308359",
    d: "M30.373,9.266a4.36,4.36,0,0,0-1.659-3.482c.228-2.7-2.793-4.751-5.356-3.794a3.474,3.474,0,0,0-5.6-.739A3.467,3.467,0,0,0,12.57,2.9a4.053,4.053,0,0,0,.914,7.987c.058,2.219,2.544,3.944,5.039,3.621a4.453,4.453,0,0,0,4.232,2.882,4.367,4.367,0,0,0,4.455-3.962,4.129,4.129,0,0,0,3.163-4.161",
    transform: "translate(15.375 0.245)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308360",
    "data-name": "Path 308360",
    d: "M12.57,2.595a4.05,4.05,0,0,0-.5,7.709,4.045,4.045,0,0,1,1.205-6.718,1.551,1.551,0,0,0,.791-.71A3.608,3.608,0,0,1,17.748.939,3.466,3.466,0,0,0,12.57,2.595",
    transform: "translate(15.375 0.549)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308361",
    "data-name": "Path 308361",
    d: "M18.7,8.182a4.129,4.129,0,0,0,3.163-4.161V3.979a.6.6,0,0,0-1.2-.045l0,.086A2.924,2.924,0,0,1,18.494,7,1.219,1.219,0,0,0,17.5,8.1a3.088,3.088,0,0,1-2.3,2.707l-.073.024a.6.6,0,0,0,.38,1.137A4.281,4.281,0,0,0,18.7,8.182",
    transform: "translate(23.882 5.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308362",
    "data-name": "Path 308362",
    d: "M29.376,5.838c.149-2.717-3.04-4.892-5.568-4.1A3.95,3.95,0,0,0,17.951.967,3.926,3.926,0,0,0,12.514,2.8a4.454,4.454,0,0,0,.852,8.7,4.561,4.561,0,0,0,3.687,3.564v4.745a.4.4,0,0,0,.4.4h4.059a.4.4,0,0,0,.4-.4V17.883c2.576.49,5.576-.928,5.917-3.894,3.383-.794,4.295-6.019,1.546-8.152m-1.991,7.434a.4.4,0,0,0-.325.367c-.22,4.145-6.6,4.884-7.905.972a.4.4,0,0,0-.377-.267c-4.279.713-6.787-5.091-2.128-5.571a.4.4,0,0,0,.4-.267,2.4,2.4,0,0,1,3.616-1.15A.4.4,0,0,0,21.13,6.7a3.2,3.2,0,0,0-4.722,1.266,3.2,3.2,0,0,0-1.4.38,3.081,3.081,0,0,1-.493-2.054c.149-1.475,1.748-2.61,2.89-1.182A.4.4,0,0,0,18,4.57c-2.02-2.1-4.022-.293-4.282,1.627a3.912,3.912,0,0,0,.637,2.612,3.154,3.154,0,0,0-.985,1.887,3.651,3.651,0,0,1-.445-7.172.4.4,0,0,0,.283-.267,3.092,3.092,0,0,1,4.57-1.449.4.4,0,0,0,.55-.063,3.093,3.093,0,0,1,4.921.647.4.4,0,0,0,.506.21c2.125-.888,5.094,1.009,4.814,3.385a.411.411,0,0,0,.157.354C31.208,8.07,30.4,12.8,27.385,13.272",
    transform: "translate(15.13 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308363",
    "data-name": "Path 308363",
    d: "M13.625,9.259a1.929,1.929,0,0,1-1.449-.838A.4.4,0,0,1,12.857,8c.312.561,1.15.634,1.756-.079a3.579,3.579,0,0,1,4.339-.168c.1.058,1.771.928,2.379.06.029-.034.744-.9-.32-2.277a.4.4,0,0,1-.047-.414c.5-1.093-.354-2.272-1.96-2.6a.4.4,0,0,1-.286-.49.4.4,0,0,1,.49-.286c1.915.375,3.105,1.97,2.568,3.485a2.507,2.507,0,0,1,.162,3.11c-1.1,1.4-3.3.162-3.4.1a2.747,2.747,0,0,0-3.372.063A2.225,2.225,0,0,1,13.625,9.259Z",
    transform: "translate(19.632 2.794)",
    fill: "#515255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentalHealthNewIcon1);
export default __webpack_public_path__ + "static/media/Mental_Health_New_Icon_1.20889dfde3ffefb5a5e2f4f5449e7e11.svg";
export { ForwardRef as ReactComponent };